module.exports = __webpack_public_path__ + "22dbe8ef253ea3d21f8d0afd028c2f36.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/feedbacks/review-1.png
// module id = 01gH
// module chunks = 0